var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-edit-page"},[(_vm.article)?_c('article-editor',{attrs:{"article":_vm.article}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }